import React from 'react';
import SharePdfButton from './SharePdfButton';
import { useDepartment } from '../contexts/DepartmentContext';
import { buildOrderDoc } from '../utils/orderPdf';
import { orderPdfFilename, orderPdfTitle } from '../utils/orderPdfMeta';
import { BTN } from '../constants/buttons';

// Unified order PDF control — one "Download / Print" dropdown (Download PDF /
// Print… / Share…) matching the budget pages. Thin wrapper over the shared
// SharePdfButton: the order doc is built by buildOrderDoc (pure pdfmake) and
// SharePdfButton owns generation + the Download/Print/Share actions. Replaces
// the old separate Print (window.print + OrderPrintLayout) and Share buttons.
function OrderPdfButton({ order, supplierContact = null, dropDirection = 'down' }) {
  // Role flags drive the document title (PO: for buyer/admin, ORD-XXX otherwise).
  const { isAdmin, isBuyer } = useDepartment();
  if (!order) return null;

  // 🔀 **THE FILENAME AND TITLE RULES MOVED TO `utils/orderPdfMeta.js` ON
  // 2026-08-10** — including the `PO-PO-147` double-prefix fix and the legacy
  // bare-`147` branch, both of which are documented in full at their new home.
  // They moved because the order ACTIONS MENU now offers Download / Print /
  // Share as items and has to produce the identical document identity; a second
  // copy of this arithmetic is exactly how the doubled prefix happened once.
  // The props handed to `SharePdfButton` below are unchanged, which
  // `OrderPdfButton.test.js` pins on both the prefixed and legacy branches.
  const filename = orderPdfFilename(order);
  const title = orderPdfTitle(order, { isAdmin, isBuyer });

  return (
    <SharePdfButton
      renderPdfMakeDoc={() => buildOrderDoc({ order, supplierContact, isAdmin, isBuyer })}
      filename={filename}
      title={title}
      orientation="portrait"
      dropDirection={dropDirection}
      className={BTN.secondary}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
      </svg>
      Download / Print
      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 ml-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </SharePdfButton>
  );
}

export default OrderPdfButton;
